import React from 'react';
import Header from '../components/header';
import HeroSection from '../components/sections/heroSection';
import PortfolioSection from '../components/sections/portfolioSection';
import ProfileSection from '../components/sections/profileSection';
import SectionsSection from '../components/sections/sectionsSection';
import ReviewsSection from '../components/sections/reviewsSection';
import Footer from '../components/sections/footer';
import MobileContactBar from '../components/mobileContactBar';

const HomePage: React.FC = () => {
  return (
    <div className="mx-4 sm:mx-16 md:mx-24 lg:mx-32 xl:mx-64 2xl:mx-80">
      <Header />
      <HeroSection />
      <PortfolioSection title="Portfolio Projects" showAiPortfolioLink />
      <ProfileSection />
      <SectionsSection />
      <ReviewsSection />
      <Footer />
      <MobileContactBar />
    </div>
  );
};

export default HomePage;
